import React, { Component } from 'react'
import Nav from '../Component/Nav/Nav'

class Layout extends Component {
    render() {
        return (
            <div className="h-full">
                <Nav />
                <main className="h-full">
                    {this.props.children}
                </main>
            </div>
        )
    }
}

export default Layout
